const containerDesktop={
  boxSizing:"border-box",
}

const containerMobile={
  width:"100%",
  border:"0px solid #fff",
  position: "relative",
  float:"left",
  
}

const styles = {
  containerStyles:window.innerWidth>899?containerDesktop:containerMobile,
}

export default styles;
